(function(){
  var wrap = document.getElementById('pp-pedigree-wrap');
  if (!wrap) return;

  var nodes = [].slice.call(wrap.querySelectorAll('.pp-node'));
  var lineIds = ['pp-l1','pp-l2','pp-l3','pp-l4','pp-l5','pp-l6'].filter(function(id){
    return document.getElementById(id);
  });

  var timers = [];
  function clearTimers(){
    timers.forEach(clearTimeout);
    timers = [];
  }

  function reset(){
    clearTimers();
    nodes.forEach(function(n){
      if (!n.classList.contains('pp-root')) n.classList.remove('pp-visible');
    });
    lineIds.forEach(function(id){
      document.getElementById(id).classList.remove('pp-draw');
    });
  }

  function reveal(){
    clearTimers();

    var OVERLAP = 350;
    var PAUSE   = 300;

    var pairs = [];
    if (lineIds.indexOf('pp-l1') > -1 && lineIds.indexOf('pp-l2') > -1) {
      pairs.push({lines:['pp-l1','pp-l2'], nodeIdx:[1,2]});
    }
    if (lineIds.indexOf('pp-l3') > -1 && lineIds.indexOf('pp-l5') > -1) {
      pairs.push({lines:['pp-l3','pp-l5'], nodeIdx:[3,5]});
    }
    if (lineIds.indexOf('pp-l4') > -1 && lineIds.indexOf('pp-l6') > -1) {
      pairs.push({lines:['pp-l4','pp-l6'], nodeIdx:[4,6]});
    }

    var t = 150;
    pairs.forEach(function(pair){
      var lineStart = t;
      var nodeStart = lineStart + OVERLAP;

      pair.lines.forEach(function(lineId){
        timers.push(setTimeout(function(){
          document.getElementById(lineId).classList.add('pp-draw');
        }, lineStart));
      });

      pair.nodeIdx.forEach(function(idx){
        timers.push(setTimeout(function(){
          if (nodes[idx]) nodes[idx].classList.add('pp-visible');
        }, nodeStart));
      });

      t = nodeStart + PAUSE;
    });
  }

  wrap.addEventListener('mouseenter', reveal);
  wrap.addEventListener('mouseleave', reset);
  wrap.addEventListener('focus', reveal);
  wrap.addEventListener('blur', reset);
})();

(function(){
  var toggle = document.getElementById('pp-desc-toggle');
  var body = document.getElementById('pp-desc-body');
  var section = document.getElementById('pp-info-section');
  if (!toggle || !body || !section) return;

  var restoreAnchor = body.nextSibling;
  var originalParent = body.parentNode;
  var mq = window.matchMedia('(max-width:900px)');

  function place(isMobile){
    if (isMobile) {
      section.insertBefore(toggle, section.firstChild);
      section.insertBefore(body, toggle.nextSibling);
    } else {
      originalParent.insertBefore(toggle, restoreAnchor);
      originalParent.insertBefore(body, restoreAnchor);
    }
  }

  place(mq.matches);
  mq.addEventListener('change', function(e){ place(e.matches); });
})();

(function(){
  var cross = document.getElementById('pp-cross');
  var section = document.getElementById('pp-info-section');
  if (!cross || !section) return;

  var originalParent = section.parentNode;
  var originalNext = section.nextSibling;
  var mq3 = window.matchMedia('(max-width:900px)');

  function placeSection(isMobile){
    if (isMobile) {
      cross.parentNode.insertBefore(section, cross.nextSibling);
    } else {
      originalParent.insertBefore(section, originalNext);
    }
  }

  placeSection(mq3.matches);
  mq3.addEventListener('change', function(e){ placeSection(e.matches); });
})();

(function(){
  var cart = document.getElementById('pp-addtocart');
  var section = document.getElementById('pp-info-section');
  if (!cart || !section) return;

  var originalParent = cart.parentNode;
  var restoreAnchor = cart.nextSibling;
  var mq2 = window.matchMedia('(max-width:900px)');

  function placeCart(isMobile){
    if (isMobile) {
      section.parentNode.insertBefore(cart, section.nextSibling);
    } else {
      originalParent.insertBefore(cart, restoreAnchor);
    }
  }

  placeCart(mq2.matches);
  mq2.addEventListener('change', function(e){ placeCart(e.matches); });
})();

(function(){
  var headers = document.querySelectorAll('.pp-accordion-header');
  headers.forEach(function(header){
    header.addEventListener('click', function(){
      header.classList.toggle('is-open');
      var body = header.nextElementSibling;
      if (body) body.classList.toggle('is-open');
    });
  });
})();

(function(){
  var photo = document.getElementById('pp-photo');
  var lightbox = document.getElementById('pp-lightbox');
  var closeBtn = document.getElementById('pp-lightbox-close');
  if (!photo || !lightbox || !closeBtn) return;

  photo.addEventListener('click', function(){
    lightbox.classList.add('is-open');
  });
  closeBtn.addEventListener('click', function(){
    lightbox.classList.remove('is-open');
  });
  lightbox.addEventListener('click', function(e){
    if (e.target === lightbox) lightbox.classList.remove('is-open');
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') lightbox.classList.remove('is-open');
  });
})();
